import { useEffect, useRef, useState } from 'react';
import Header from '../../components/header/Header';
import './administrator.css';
import axios from 'axios';
import Swal from 'sweetalert2';

function AdministratorCL() {
  const [turnData, setTurnData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchDashboardAndLogDates = async () => {
      getTurns();
    }

    fetchDashboardAndLogDates(); 
  }, [page]);

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 1 && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [hasMore]);

  const getTurns = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/shipment?page=${page}&limit=10`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
        },
      });

      if(response.data.data.shipments.length > 0) {
        setTurnData((prevData) => [...prevData, ...response.data.data.shipments]);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Error al consultar, por favor intentalo de nuevo",
        icon: "error",
      });
    }
  }

  const getStatus = (id) => {
    switch (id) {
      case 1:
        return "Etiqueta emitida";
        break;
      case 2:
        return "Pesaje";
        break;
      case 3:
        return "Documentado";
        break;
      case 4:
        return "Finalizado";
        break;
      case 5:
        return "Cancelado en Pesador";
        break;
      case 6:
        return "Cancelado en Mostrador"
      default:
        return "";
        break;
    }
  };

  const cancelWeigher = async (id) => {
    const { value: description, isConfirmed } = await Swal.fire({
      title: "Para cancelar el turno, ingresa el motivo",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Cancelar turno",
      cancelButtonText: "No cancelar turno",
      showLoaderOnConfirm: true,
      preConfirm: (inputValue) => {
        if (!inputValue) {
          Swal.showValidationMessage("Debes ingresar un motivo");
          return false;
        }
        return inputValue;
      },
      allowOutsideClick: () => !Swal.isLoading()
    });

    if (isConfirmed && description) {
      try {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/cancel`;
        const body = {
          id: id,
          description: description,
          user_id: localStorage.getItem("light-load-email")
        };
        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          }
        });
  
        Swal.fire({
          icon: "success",
          title: "Turno cancelado exitosamente"
        }).then((result) => {
          window.location.reload()
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error al cancelar turno",
          text: error.response?.data?.message || "Ocurrió un error inesperado"
        });
      }
    }
  }

  const reactiveWeigher = async (id) => {
    const result = await Swal.fire({
      title: "Seguro que quieres reactivar este turno?",
      showCancelButton: true,
      confirmButtonText: "Reactivar",
      cancelButtonText: "Cancelar"
    });

    if(result.isConfirmed) {
      try {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/reactivate_turn/${id}`;
        const body = {
          user_id: localStorage.getItem("light-load-email")
        }

        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          }
        });

        window.location.reload()
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "No se pudo reactivar el turno", "error");
      }
    }
  }

  return(
    <>
    <div className="body-administrator">
      <Header />

      <h4>Administrador</h4>

      <div className="table-container">
        <div className='content-table' ref={containerRef}>
          <table>
            <thead>
              <tr>
                <th># Turno</th>
                <th># Embarque</th>
                <th>Piezas</th>
                <th>Descripción</th>
                <th>Destino</th>
                <th>usuario</th>
                <th>Fecha creacion</th>
                <th>id cantidad</th>
                <th>user_quantity</th>
                <th>date_quantity</th>
                <th># Guía</th>
                <th>usuario Guía</th>
                <th>Fecha Guía</th>
                <th>Status</th>
                <th>Pesador</th>
              </tr>
            </thead>

            <tbody>
              {turnData.map((turn, index) => (
                <tr>
                  <td style={{ minWidth: "100px" }}>{turn.turn_number}</td>
                  <td style={{ minWidth: "130px" }}>{turn.tag_number}</td>
                  <td style={{ minWidth: "100px" }}>{turn.pieces}</td>
                  <td style={{ minWidth: "150px" }}>
                    {turn.merchandise_description}
                  </td>
                  <td style={{ minWidth: "100px" }}>{turn.destination}</td>
                  <td style={{ minWidth: "150px" }}>{turn.user_create}</td>
                  <td style={{ minWidth: "180px" }}>{turn.date_create}</td>
                  <td style={{ minWidth: "150px", textAlign:  turn.quantity_id ? "" : "center" }}>{turn.quantity_id ? turn.quantity_id : "-----"}</td>
                  <td style={{ minWidth: "150px", textAlign:  turn.user_quantity ? "" : "center" }}>{turn.user_quantity ? turn.user_quantity :  "-----"}</td>
                  <td style={{ minWidth: "180px", textAlign:  turn.date_quantity ? "" : "center" }}>{turn.date_quantity ? turn.date_quantity :  "-----"}</td>
                  <td style={{ minWidth: "150px", textAlign:  turn.awb ? "" : "center" }}>{turn.awb ? turn.awb :  "-----"}</td>
                  <td style={{ minWidth: "150px", textAlign:  turn.user_awb ? "" : "center" }}>{turn.user_awb ? turn.user_awb :  "-----"}</td>
                  <td style={{ minWidth: "200px", textAlign:  turn.date_awb ? "" : "center" }}>{turn.date_awb ? turn.date_awb :  "-----"}</td>
                  <td style={{ minWidth: "150px" }}>
                    {turn.status ? getStatus(turn.status) : ""}
                  </td>
                  <td>
                    <div className="admin-td">
                      {turn.status === 5 || turn.status === 6 ? (
                        <button className="reactive-btn-wc" onClick={() => reactiveWeigher(turn.id)}>Reactivar</button>
                      ) : (
                        <button className="cancel-btn-wc" onClick={() => cancelWeigher(turn.id)}>Canelar</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

    </div>
    </>
  )
}

export default AdministratorCL;